import AddPolicy from "../../../../components/company/organization/policy-configuration/add-policy/AddPolicy"

const AddPolicyPage = () => {
    return <AddPolicy/>
}

export default AddPolicyPage;